import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { productActions } from "../store/slices/productReducer";

interface Product {
  id_product: number;
  name: string;
  price_sell: string;
  price_bought: string;
  stock: number;
  photo?: string;
  quantity?: number;
}

export const useCart = () => {
  const dispatch = useDispatch();

  const { selectedProducts, quantities, totalPrice, boughtPrice } = useSelector(
    (state: RootState) => state.product
  );

  const addProduct = (product: Product, quantity?: number) => {
    dispatch(productActions.addProduct({ product, quantity }));
  };

  const updateQuantity = (productId: number, quantity: number) => {
    dispatch(productActions.updateQuantity({ productId, quantity }));
  };

  const removeProduct = (productId: number) => {
    dispatch(productActions.removeProduct(productId));
  };

  const clearCart = () => {
    dispatch(productActions.clearCart());
  };

  const setSelectedProducts = (products: Product[]) => {
    dispatch(productActions.setSelectedProducts(products));
  };

  const setQuantities = (
    quantities:
      | Record<number, number>
      | ((prev: Record<number, number>) => Record<number, number>)
  ) => {
    dispatch(productActions.setQuantities(quantities));
  };

  const setTotalPrice = (price: number | ((prev: number) => number)) => {
    dispatch(productActions.setTotalPrice(price));
  };

  const setBoughtPrice = (price: number) => {
    dispatch(productActions.setBoughtPrice(price));
  };

  const calculateTotals = () => {
    dispatch(productActions.calculateTotals());
  };

  return {
    // State
    selectedProducts,
    quantities,
    totalPrice,
    boughtPrice,

    // Actions
    addProduct,
    updateQuantity,
    removeProduct,
    clearCart,
    setSelectedProducts,
    setQuantities,
    setTotalPrice,
    setBoughtPrice,
    calculateTotals,
  };
};
